/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValue } from '../../models/key-value';

export interface GlobalMappingSettingsGetDropdownListUiPreferences$Params {
}

export function globalMappingSettingsGetDropdownListUiPreferences(http: HttpClient, rootUrl: string, params?: GlobalMappingSettingsGetDropdownListUiPreferences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KeyValue>>> {
  const rb = new RequestBuilder(rootUrl, globalMappingSettingsGetDropdownListUiPreferences.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KeyValue>>;
    })
  );
}

globalMappingSettingsGetDropdownListUiPreferences.PATH = '/api/GlobalMappingSettings/ddlistUIPreferences';
